import { render, staticRenderFns } from "./PosInvoices.vue?vue&type=template&id=fd5eebde&scoped=true"
import script from "./PosInvoices.vue?vue&type=script&lang=js"
export * from "./PosInvoices.vue?vue&type=script&lang=js"
import style0 from "./PosInvoices.vue?vue&type=style&index=0&id=fd5eebde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5eebde",
  null
  
)

export default component.exports